import { useSyncExternalStore } from 'react';
import { getServerSnapshot, getSnapshot, subscribe } from '../services/debugStore';

export function useDebugStore() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
